const TAB = '/notifications' as const;
export const ALARMS_NOTIFICATIONS = `${TAB}/alarms` as const;
